import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { TReviewsList } from 'shared/types/TReviewsService';

const initialState: TReviewsList = {
  items: [],
  total: 0,
};

export const reviewsSlice = createSlice({
  name: 'reviews',
  initialState,
  reducers: {
    setReviews: (_, { payload }: PayloadAction<TReviewsList>) => payload,
  },
});

export const { setReviews } = reviewsSlice.actions;
